export enum PrinterType {
  LASER = 'LASER',
  FILE = 'FILE',
}

export enum ApiQueryParam {
  GETLASERSTATIONS = 'GetLaserStations',
  GETLASERPRINTERS = 'GetLaserPrinters',
  GETWEATHEROVERRIDE = 'GetWeatherOverride',
}

export enum Alert {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  WEATHEROVERRIDEERROR = 'weatherOverrideError',
}

export enum AirlineType {
  AS = 'AS',
  QX = 'QX',
}

export enum WeatherOverrideAirline {
  AS = 'AS',
  QX = 'QX',
  NONE = 'NONE',
}
